<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Items Order Summary  
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group>
              <b-input-group-prepend><label style="width:120px !important;">Order Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:80px !important;">Item </label></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <div class="clearfix">
                  <div class="float-right">
                      <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                      <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </div>
                </div>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
        <template v-slot:cell(tanggal)="data">
          <span v-if="(data.item.tanggal)">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
          </span>
        </template>
        <template v-slot:cell(qtyOrder)="data">
          {{data.item.qtyOrder | numFormat}}
        </template>
        <template v-slot:cell(qtyDeliver)="data">
          {{data.item.qtyDeliver | numFormat}}
        </template>
        <template v-slot:cell(qtyChecker)="data">
          {{data.item.qtyChecker | numFormat}}
        </template>
        <template v-slot:cell(qtyReceipt)="data">
          {{data.item.qtyReceipt | numFormat}}
        </template>
        <template v-slot:cell(qtyRetur)="data">
          {{data.item.qtyRetur | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferIn)="data">
          {{data.item.qtyTransferIn | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferOut)="data">
          {{data.item.qtyTransferOut | numFormat}}
        </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>     
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item " :centered="true">
        <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
    </b-modal>        

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import moment from "moment";
import order from "../../apis/bakeryorder";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuItem from "../lookup/lkuItemLazzy";
import toastr from "mini-toastr";
toastr.init();

export default {
  components :{Loading,lkuCustomer, lkuItem, myNumber},
  mixins: [validationMixin],
  validations: {
        // frmdata: {
        //     itemno: { required },
        //     tglRetur: { required},
        //     qtyRetur: { required},
        //     sales: { required},
        //     customer_id: { required },
        // },
  },   
  data() {
    return {
      fields: [
          {
            key: "tanggal",
            label: "Order Date",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty Order",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyChecker",
            tdClass: "text-right",
            label: "Qty Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyDeliver",
            tdClass: "text-right",
            label: "Qty Deliver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyReceipt",
            tdClass: "text-right",
            label: "Qty Etalase Masuk",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyRetur",
            tdClass: "text-right",
            label: "Qty Retur",
            thStyle: "width:100px",
            sortable: true
          },
          // {
          //   key: "qtyTransferIn",
          //   tdClass: "text-right",
          //   label: "Qty Transfer IN",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
          // {
          //   key: "qtyTransferOut",
          //   tdClass: "text-right",
          //   label: "Qty Transfer OUT",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: null,
        sortDesc: false,
        headcategory:null
      },
      limit:15,
      pagination: false,
      items:[],
      model:{},showFrm:false,
      frmdata: {qtyRetur:0, itemno:'', tanggal:''},
      lkuItemShow:false,
      itemList:{},
      lkuCustomerShow:false,
        uanguser: this.$store.state.user.matauang,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      headCategories:[], itemCategories:[]
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },   
  methods: {

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.orderlist) {
            this.tblData[key] = filter.orderlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.orderlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.orderlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  console.log("#this.tblData: ", this.tblData);
                  const list = await order.itemlist(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await order.itemlist(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },    
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemno = '';
        this.tblData.itemname =  '';
        this.tblData.tgl1 = '';
        this.tblData.tgl2 = '';
        this.refresh();
    },    
    itemChange: function () {
        this.tblData.itemno = '';
    },
    customerChange: function () {
        this.tblData.customer_id = '';
    },        
    saveFilter() {
      const keys = ['tgl1', 'tgl2','itemno', 'itemname'];
      let filtered = false;
      const orderlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              orderlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          orderlist.page=this.tblData.page;
          orderlist.limit=this.tblData.limit;
          orderlist.sortBy=this.tblData.sortBy;
          orderlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.orderlist=orderlist;
          this.$store.commit("filter", filter);
      }
    },    
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemname = lkuData.selected.itemname;
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.itemname = lkuData.selected.itemname;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.iteminfo = lkuData.selected.itemname + '  |  '+lkuData.selected.partnumber;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.unitprice = lkuData.selected.unitprice;
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await order.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
